import { Typography } from '@montugroup/design-system';
import type { ReactNode } from 'react';

export const LATIN1_FORMATTING_HINT = 'Formatting has been adjusted for compatibility.';

export type GetLatin1HelperMessageProps = {
  /** Error text to show. If an array, each item is rendered on a new line. */
  errorMessage?: string | string[];
  showFormattingHint?: boolean;

  /** Default helper text when there is no error or formatting hint (e.g. character count). */
  defaultHelperText?: ReactNode;

  /** Custom formatting hint to display when formatting was adjusted. Falls back to LATIN1_FORMATTING_HINT if not provided. */
  formattingHint?: string;
};

export const getLatin1HelperMessage = ({
  errorMessage,
  showFormattingHint = false,
  formattingHint = LATIN1_FORMATTING_HINT,
  defaultHelperText,
}: GetLatin1HelperMessageProps) => {
  const errors = Array.isArray(errorMessage) ? errorMessage.filter(Boolean) : errorMessage ? [errorMessage] : [];

  const hasError = errors.length > 0;
  const hasHint = showFormattingHint && Boolean(formattingHint);

  if (!hasError && !hasHint) {
    return defaultHelperText ?? null;
  }

  return (
    <>
      {hasError && (
        <Typography variant="caption" color="error" sx={{ display: 'block', whiteSpace: 'pre-line' }}>
          {errors.join('\n')}
        </Typography>
      )}

      {hasHint && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {formattingHint}
        </Typography>
      )}
    </>
  );
};
